module.exports = __webpack_public_path__ + "static/index/assets/img/icon_4.ce2a4a47.png";